import { Button, cn, Tooltip } from '@heroui/react';
import { MdOutlineMonetizationOn } from 'react-icons/md';
import { useIsTruncated } from '@/hooks/useIsTruncated';

export type InvoiceButtonProps = {
  fileName: string;
  variant?: 'sm' | 'md';
  onClickHandler: () => void;
};

export const InvoiceButton = ({ fileName, variant = 'sm', onClickHandler }: InvoiceButtonProps) => {
  const { ref, isTruncated } = useIsTruncated();

  const fileNameElement = (
    <span ref={ref} className="truncate">
      {fileName}
    </span>
  );

  const buttonHeight = variant === 'sm' ? 'h-[24px]' : 'h-[26px]';

  return (
    <Button
      className={cn(
        'max-w-full px-3 flex items-center gap-2 rounded-full bg-transparent border border-base-10 overflow-hidden',
        buttonHeight,
      )}
      disableAnimation
      disableRipple
      onPress={onClickHandler}
      startContent={<MdOutlineMonetizationOn size={16} className="text-black shrink-0" />}
    >
      {isTruncated ? (
        <Tooltip content={fileName} placement="top" delay={300}>
          <span className="truncate">{fileNameElement}</span>
        </Tooltip>
      ) : (
        fileNameElement
      )}
    </Button>
  );
};
